// AI Generated Test
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';
import { SessionService } from '@monsido/core/session/session.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { NgForm } from '@angular/forms';
import { FormUtils } from '@client/ng2/shared/form-utils';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'form-global-policy-dialog-rule-standard',
    templateUrl: './form-global-policy-dialog-rule-standard.component.html',
    standalone: false,
})
export class FormGlobalPolicyDialogRuleStandardComponent implements OnInit, AfterViewInit {
    @Input() cRule: any;
    @Input() monDialogId: any;

    @ViewChild('policyRuleForm') policyRuleForm?: NgForm;

    isSudo: boolean = false;
    areAllSubEntriesSelected: boolean = false;
    cssFilters: any[] = [];
    typeOptions: any[] = [];
    dropdownOptions: any[] = [];
    selectedOption: any = {};
    subEntry: any = { options: [] };
    inverseOptions: any[] = [];
    caseSensitiveOptions: any[] = [];
    multilineOptions: any[] = [];
    filterTypeOptions: any[] = [];

    constructor (
        private policyFormHelperService: PolicyFormHelperService,
        private translateService: TranslateService,
        private monDialog: MonDialog,
        private sessionService: SessionService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngAfterViewInit () {
        this.monDialog.setFocus(this.monDialogId, this.policyRuleForm);
    }

    activate (): void {
        this.isSudo = this.sessionService.isSudo;
        this.areAllSubEntriesSelected = false;

        if (this.cRule.type === 'page_html') {
            this.setupCssFilterTypeOptions();
            this.cssFilters = [];
            if (this.cRule.css_filters) {
                if (Array.isArray(this.cRule.css_filters.limit)) {
                    this.cRule.css_filters.limit.forEach((element: any) => {
                        this.cssFilters.push({
                            name: 'limit',
                            value: element,
                        });
                    });
                }

                if (Array.isArray(this.cRule.css_filters.exclude)) {
                    this.cRule.css_filters.exclude.forEach((element: any) => {
                        this.cssFilters.push({
                            name: 'exclude',
                            value: element,
                        });
                    });
                }
            }
            if (this.cssFilters.length === 0) {
                this.addFilterType();
            }
        }

        this.policyFormHelperService.setRuleType(this.cRule.type);
        this.setupInverseOptions();
        this.setupTypeOptions();
        this.setupCaseSensitiveOptions();
        this.setupRuleSubEntries();
        this.setupMultilineOptions();
        if (!this.cRule.name) {
            this.chooseOperator(this.typeOptions.length > 0 ? this.typeOptions[0] : {});
        } else {
            this.chooseOperator(
                this.typeOptions.find((type: any) => {
                    return type.type === this.cRule.operator;
                }),
            );
        }
    }

    isSelectorValid (value: string): boolean {
        try {
            document.querySelector(value);
        } catch (error) {
            return false;
        }
        return true;
    }

    isFormValid (): boolean {
        if (!this.policyRuleForm?.valid) {
            return false;
        }

        if (this.selectedOption.type === 'css_selector' && this.cRule.query && !this.isSelectorValid(this.cRule.query)) {
            return false;
        }

        if (this.cRule.type === 'page_html') {
            for (let i = 0; i < this.cssFilters.length; i += 1) {
                if (this.cssFilters[i].value && !this.isSelectorValid(this.cssFilters[i].value)) {
                    return false;
                }
            }
        }

        return true;
    }

    setupCssFilterTypeOptions (): void {
        this.filterTypeOptions = [
            {
                value: 'limit',
                name: this.translateService.getString('Limit search'),
            },
            {
                value: 'exclude',
                name: this.translateService.getString('Exclude'),
            },
        ];
    }

    addFilterType (): void {
        this.cssFilters.push({ name: 'limit', value: '' });
    }

    removeFilterType (index: number): void {
        this.cssFilters.splice(index, 1);
    }

    setupInverseOptions (): void {
        this.inverseOptions = [
            {
                name: this.translateService.getString('Containing'),
                value: false,
            },
            {
                name: this.translateService.getString('Not containing'),
                value: true,
            },
        ];
    }

    setupCaseSensitiveOptions (): void {
        this.caseSensitiveOptions = [
            {
                name: this.translateService.getString('Not case sensitive'),
                value: false,
            },
            {
                name: this.translateService.getString('Case sensitive'),
                value: true,
            },
        ];
    }

    setupMultilineOptions (): void {
        this.multilineOptions = [
            {
                name: this.translateService.getString('Single line'),
                value: false,
            },
            {
                name: this.translateService.getString('Multiline'),
                value: true,
            },
        ];
    }

    setupTypeOptions (): void {
        this.typeOptions = this.policyFormHelperService.getOptionsByRuleType();
        this.dropdownOptions = this.policyFormHelperService.getMenuDropdownOptionsByRuleType((option) => this.chooseOperator(option));
    }

    setupRuleSubEntries (): void {
        this.subEntry = this.policyFormHelperService.getRuleSubEntries();
        this.checkSelectedSubEntries();
    }

    chooseOperator (option: any): void {
        this.selectedOption = option;
        this.cRule.operator = option.type;
        if (this.cRule.operator === 'conforms_with') {
            this.cRule.inverse = false;
        }
        if (this.cRule.type === 'page_html') {
            if (!this.cRule.css_filters) {
                this.cRule.css_filters = {
                    limit: [],
                    exclude: [],
                };
            }
        }
    }

    selectAllSubEntries (): void {
        if (this.cRule.sub_entry.length === this.subEntry.options.length) {
            this.cRule.sub_entry = [];
            this.areAllSubEntriesSelected = false;
        } else {
            this.cRule.sub_entry = this.subEntry.options.map((entry: any) => {
                return entry.value;
            });
            this.areAllSubEntriesSelected = true;
        }
    }

    checkSelectedSubEntries (): void {
        this.areAllSubEntriesSelected = this.subEntry.options.length > 0 && this.subEntry.options.length === this.cRule.sub_entry.length;
    }

    getOperatorHelpBlock (): string {
        return this.policyFormHelperService.getSubjectTypeHelpBlock(this.cRule.operator);
    }

    save (): void {
        const newRule = safeClone(this.cRule);
        if (newRule.operator !== 'regex') {
            newRule.multiline = false;
        }
        if (this.cRule.type === 'page_html') {
            newRule.css_filters.limit = [];
            newRule.css_filters.exclude = [];

            this.cssFilters.forEach((element: any) => {
                if (element.name === 'limit' && element.value !== '') {
                    newRule.css_filters.limit.push(element.value);
                }
                if (element.name === 'exclude' && element.value !== '') {
                    newRule.css_filters.exclude.push(element.value);
                }
            });
        }

        if (Array.isArray(newRule.sub_entry)) {
            newRule.sub_entry = newRule.sub_entry.join(',');
        }
        FormUtils.markFormAsPristine(this.policyRuleForm);
        this.monDialog.close(this.monDialogId, newRule);
    }

    cssFiltersTrackFn (index: number) {
        return index;
    }
}
